import Vue from 'vue'
import Vuex from 'vuex'
import formData from './form-data'
import legacy from './legacy'
import ui from './ui'
import payment from './payment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    formData,
    payment,
    legacy,
    ui
  }
})
